import { columns } from "../../../../dtos/columns";
import { MutuoSeleccionadoGenMasiva } from "../models/mutuoSeleccionadoGenMasiva";
import { RowGeneracionMasiva } from "../models/rowGeneracionMasiva";
import { Checkbox } from "@mui/material";
import Conversiones from "../../../../utils/conversiones";
import { numericFormatter } from "react-number-format";
import { format } from "rut.js";

interface IProps {
    mutuosEndosar: MutuoSeleccionadoGenMasiva[];
    data: any,
    setMutuosEndosar: React.Dispatch<React.SetStateAction<MutuoSeleccionadoGenMasiva[]>>;
}

export function useColumns({mutuosEndosar, data, setMutuosEndosar} : IProps){

    const COLUMNS: columns<RowGeneracionMasiva>[] = [
        {
            name: (
                <Checkbox
                    size="small"
                    checked={
                        data?.length > 0 &&
                        mutuosEndosar.length === data.length
                    }
                    onChange={(e) => {
                        if (e.target.checked && data) {
                            const allObjects = data.map((item: MutuoSeleccionadoGenMasiva) => ({
                                id: item.id,
                            }));
                            setMutuosEndosar(allObjects);
                        } else {
                            setMutuosEndosar([]);
                        }
                    }}
                />
            ),
            selector: (row: RowGeneracionMasiva) => row.id,
            cell: (row: RowGeneracionMasiva) => (
                <Checkbox
                    size="small"
                    checked={mutuosEndosar.some((m) => m.id === row.id)}
                    onChange={(e) => {
                        setMutuosEndosar((prev) => {
                        if (e.target.checked) {
                            return [
                                ...prev,
                                {
                                    id: row.id
                                },
                            ];
                        } else {
                            return prev.filter((m) => m.id !== row.id);
                        }
                        });
                    }}
                />
            ),
            allowOverflow: true,
            button: true,
            export: false,
            width: '60px',
        },
        {
            name: 'N°',
            selector: (row: RowGeneracionMasiva) => row.numero,
            sortable: true,
            sortField: 'numero',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: "Fecha endoso",
            selector: (row: RowGeneracionMasiva) => Conversiones.fechaCortaFormat((row.fechaEndoso ?? "").toString()),
            sortable: true,
            sortField: 'fechaEndoso',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'N° operación',
            selector: (row: RowGeneracionMasiva) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'RUT cliente',
            selector: (row: RowGeneracionMasiva) => format(row.rutCliente),
            sortable: true,
            sortField: 'rutCliente',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Nombre cliente',
            selector: (row: RowGeneracionMasiva) => row.nombreCliente,
            sortable: true,
            sortField: 'nombreCliente',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: "Fecha escritura",
            selector: (row: RowGeneracionMasiva) => Conversiones.fechaCortaFormat((row.fechaEscritura ?? "").toString()),
            sortable: true,
            sortField: 'fechaEscritura',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'Plazo crédito',
            selector: (row: RowGeneracionMasiva) => row.plazoCredito,
            sortable: true,
            sortField: 'plazoCredito',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Meses de gracia',
            selector: (row: RowGeneracionMasiva) => row.mesesGracia,
            sortable: true,
            sortField: 'mesesGracia',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'N° dividendos impagos',
            selector: (row: RowGeneracionMasiva) => row.numDivImpagos,
            sortable: true,
            sortField: 'numDivImpagos',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Finalidad crédito',
            selector: (row: RowGeneracionMasiva) => row.finalidadCredito,
            sortable: true,
            sortField: 'finalidadCredito',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Monto crédito',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.montoCredito.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'montoCredito',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Valor garantía',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.valorGarantia.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorGarantia',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tasa emisión',
            selector: (row: RowGeneracionMasiva) => row.tasaEmision,
            sortable: true,
            sortField: 'tasaEmision',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tasa endoso',
            selector: (row: RowGeneracionMasiva) => row.tasaEndoso,
            sortable: true,
            sortField: 'tasaEndoso',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Comuna CBR',
            selector: (row: RowGeneracionMasiva) => row.comunaCBR,
            sortable: true,
            sortField: 'comunaCBR',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'N° cupones cortados',
            selector: (row: RowGeneracionMasiva) => row.numCuponesCortados,
            sortable: true,
            sortField: 'numCuponesCortados',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: "Fecha primer div remesar",
            selector: (row: RowGeneracionMasiva) => Conversiones.fechaCortaFormat((row.fechaPrimerDivRemesar ?? "").toString()),
            sortable: true,
            sortField: 'fechaPrimerDivRemesar',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'LTV%',
            selector: (row: RowGeneracionMasiva) => row.ltv,
            sortable: true,
            sortField: 'ltv',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Valor de utilidad perdida (UF)',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.valorUtilidadPerdidaUF.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorUtilidadPerdidaUF',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Valor de utilidad perdida (CLP)',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.valorUtilidadPerdidaPeso.toFixed(0), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
            sortable: true,
            sortField: 'valorUtilidadPerdidaPeso',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Valor de venta (UF)',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.valorVentaUF.toFixed(4), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorVentaUF',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Valor de venta (CLP)',
            selector: (row: RowGeneracionMasiva) => numericFormatter(row.valorVentaPeso.toFixed(0), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
            sortable: true,
            sortField: 'valorVentaPeso',
            wrap: true,
            alling: 'left',
            export: true,
        },
    ]

    return { COLUMNS}
}